import { useAccount, useMsal } from "@azure/msal-react";
import { AppRole } from "@po-management/types";

const VALID_ROLES: AppRole[] = ["PO.AccountManager", "PO.OfficeAdmin", "PO.Director", "PO.SuperAdmin"];

export interface AppRoleState {
  roles: AppRole[];
  isAccountManager: boolean;
  isOfficeAdmin: boolean;
  isDirector: boolean;
  isSuperAdmin: boolean;
  hasAnyRole: boolean;
  isLoading: boolean;
}

export function useAppRole(): AppRoleState {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] ?? null);

  if (!account) {
    return {
      roles: [],
      isAccountManager: false,
      isOfficeAdmin: false,
      isDirector: false,
      isSuperAdmin: false,
      hasAnyRole: false,
      isLoading: true,
    };
  }

  // Extract roles from the ID token claims
  const idTokenClaims = account.idTokenClaims as Record<string, unknown> | undefined;
  const rawRoles = (idTokenClaims?.["roles"] as string[] | undefined) ?? [];
  const roles = rawRoles.filter((r): r is AppRole => VALID_ROLES.includes(r as AppRole));

  return {
    roles,
    isAccountManager: roles.includes("PO.AccountManager"),
    isOfficeAdmin: roles.includes("PO.OfficeAdmin"),
    isDirector: roles.includes("PO.Director"),
    isSuperAdmin: roles.includes("PO.SuperAdmin"),
    hasAnyRole: roles.length > 0,
    isLoading: false,
  };
}
